/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Dialog } from "../../../dialogs/Dialog";
import { IEditor } from "../../../IEditor";
import { CodeViewDialogComponent } from "./CodeViewDialogComponent";

export interface CodeViewDialog_Params {
	codeSource: string;
	language: string;
}

export class CodeViewDialog extends Dialog<CodeViewDialog_Params, void> {
	public codeSource: string;
	public language: string;

	/**
	 * Dialog constructor
	 *
	 * @param dc Dependency container
	 * @param id Dialog ID
	 * @param params Open params
	 */
	public constructor(dc: IEditor, id: string, params: CodeViewDialog_Params) {
		super(dc, id, params);

		this.codeSource = params.codeSource;
		this.language = params.language;
	}

	public getComponent(): typeof CodeViewDialogComponent {
		return CodeViewDialogComponent;
	}
}
